require('imports-loader?JSON=>window.JSON!./Scripts/Core/json2.js');
window._ = require('./Scripts/Core/underscore.js');
require('./Scripts/Core/jquery.js');
require('./Scripts/Core/jquery.parseJSON.dates.js');
require('./Scripts/Core/jquery.validate.js');
require('./Scripts/Core/jquery.clipboard.js');
require('./Scripts/Core/jquery.validate.unobtrusive.js');
require('./Scripts/App/Core/GoogleAnalyticsSlim.js');
